import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { EventsService, FundraiserService, UtilService, VariablesService } from '../../shared/services';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-bulkdonation-v1',
  templateUrl: './bulkdonation-v1.component.html',
  styleUrls: ['./bulkdonation-v1.component.scss']
})
export class BulkdonationV1Component implements OnInit, OnChanges {
  infolist = []

  @Input() config;
  @Output() submitted = new EventEmitter<any>();
  @ViewChild('incrbtn') Btn: ElementRef;

  minamt = 0;
  selected = [];
  amt = {};
  totalamt;
  btnlabel;
  active;
  timer;
  currency;
  minamount = {
    'INR': { minamt: 500, incramt: 500 },
    'GBP': { minamt: 25, incramt: 25 },
    'EUR': { minamt: 15, incramt: 15 },
    'AED': { minamt: 50, incramt: 50 },
    'SAR': { minamt: 50, incramt: 50 },
    'USD': { minamt: 30, incramt: 30 },
    'SGD': { minamt: 30, incramt: 30 }
  };

  constructor(
    private utilService: UtilService,
    private fundraiserService: FundraiserService,
    private eventsService: EventsService,
    private variablesService: VariablesService
  ) { }

  ngOnInit(): void {
    this.currency = this.config?.currency;
    this.btnlabel = `Donate ${this.utilService.formatAmount(this.config.amount, this.currency)}`;
    this.getCampaigns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config.currentValue.currency !== this.currency) {
      this.currency = this.config?.currency;
      this.selected = [];
      this.getCampaigns();
    }
    if (changes.config.currentValue.amount && this.selected?.length !== 0) {
      this.btnlabel = `Donate ${this.utilService.formatAmount(changes.config.currentValue.amount, this.currency)}` + (this.totalamt ? ` + ${this.utilService.formatAmount(this.totalamt, this.currency)}` : ``);
    } else {
      this.btnlabel = `Donate ${this.utilService.formatAmount(this.config.amount, this.currency)}`;
    }
  }

  hide(id) {
    this.selected.push(id);
    this.amt[id] = { amount: this.minamt };
    if (this.amt[id].amount === 0) {
      this.amt[id].amount = this.amt[id].amount + this.minamount[this.currency].minamt;
    }
    this.active = true;
    this.totalamt = Object.values(this.amt).reduce((a, { amount }) => a + amount, 0);
    this.eventsService.sendSystemEvent({
      eventName: 'amountinc',
    }).subscribe(_ => _);
    this.btnlabel = `Donate ${this.utilService.formatAmount(this.config.amount, this.currency)} + ${this.utilService.formatAmount(this.totalamt, this.currency)}`;
  }

  amtchanger(value, id) {
    if (value === 'plus' && this.amt[id]?.amount < this.minamount[this.currency]?.minamt * 10) {
      this.amt[id].amount = this.amt[id].amount + this.minamount[this.currency].incramt;
    }
    if (value === 'minus') {
      if (this.amt[id].amount > this.minamount[this.currency].minamt) {
        this.amt[id].amount = this.amt[id].amount - this.minamount[this.currency].incramt;
      } else {
        this.eventsService.sendSystemEvent({
          eventName: 'amountdec',
        }).subscribe(_ => _);
        this.selected.splice(this.selected.indexOf(id), 1);
        this.amt[id].amount = 0;
        delete this.amt[id];
      }
      if (Object.keys(this.amt).length === 0) {
        this.active = false;
      }
    }
    this.totalamt = Object.values(this.amt).reduce((a, { amount }) => a + amount, 0);
    if (this.totalamt > 0) {
      this.btnlabel = `Donate ${this.utilService.formatAmount(this.config.amount, this.currency)} + ${this.utilService.formatAmount(this.totalamt, this.currency)}`;
    } else {
      this.btnlabel = `Donate ${this.utilService.formatAmount(this.config.amount, this.currency)}`;
    }
  }

  getCampaigns() {
    const qpram = '?limit=3&tags=featured&with=beneficiaryname;storyWidget&orderBy=priority_entity&sortBy=ASC&currency=' + this.currency;
    this.fundraiserService.getUrgentStoryCampaigns(qpram).subscribe((res: any) => {
      const camp_list: any[] = res.data.data;
      this.infolist = camp_list.filter(item => this.config?.campaign_id !== item?.id).filter((item, i) => i < 2);
      camp_list.forEach(res => {
        if (this.amt[res?.id]?.amount) {
          this.selected = [];
          this.totalamt = Object.values(this.amt).reduce((a, { amount }) => a + amount, 0);
          this.active = false;
          this.amt[res?.id].amount = 0;
          this.btnlabel = `Donate ${this.utilService.formatAmount(this.config.amount, this.currency)}`;
        }
      });
    });
  }

  submit() {
    if (Object.keys(this.amt).length === 0) {
      this.eventsService.sendSystemEvent({
        eventName: 'skip multi_donation',
        page_name: this.variablesService.pageName,
      }).subscribe(_ => _);
    }
    this.submitted.emit(this.amt);
  }

  campaignTimer(endDate) {
    const end: any = dayjs(endDate);
    const today: any = new Date();
    const diffTime = new Date(Math.abs(end - today));
    return diffTime.getHours();
  }

  amtRemainig(amount, goal) {
    let amt = goal - amount
    if (amt <= 0) {
      return false;
    } else {
      return Math.round(amt);
    }
  }

}
